import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import {
  TEXT_VARIANT_ITALIC_LIGHT,
  TEXT_VARIANT_LIGHT,
  Text,
} from 'mailup-web-components'

interface ItemContactFieldProps {
  label: string
}

const ItemContactField: FC<ItemContactFieldProps> = ({ label }) => {
  const intl = useIntl()

  return label.length === 0 ? (
    <Text variant={TEXT_VARIANT_ITALIC_LIGHT}>
      {intl.formatMessage({ id: 'Load.RecipientsList.EmptyData' })}
    </Text>
  ) : (
    <Text variant={TEXT_VARIANT_LIGHT} whiteSpace="nowrap" wordBreak="keep-all">
      {label}
    </Text>
  )
}

export default ItemContactField
